module.exports = __webpack_public_path__ + "media/images/closed_eye-29f55a3cec70de5b1c2c0ca019d21c23.svg";